import { colors } from '../../../shared-components/global-styles';

const webStyles = Object.freeze({
  container: {
    flexDirection: 'column',
  },
  textLeft: {
    textAlign: 'left',
  },
  discoverContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 30,
  },
  bodyContainer: {
    justifyContent: 'center',
    marginHorizontal: 5,
    marginVertical: 10,
    flexDirection: 'row',
  },
  filtersContainer: {
    paddingHorizontal: 20,
    marginBottom: 20,
    // from mock
    maxWidth: 365,
  },
  resultsContainer: {},
  filter: {
    marginTop: 15,
  },
  resetButton: {
    paddingLeft: 0,
    textAlign: 'left',
    fontSize: 12,
  },
  noResultLabel: {
    textAlign: 'center',
    color: colors.brandPrimary,
  },
  dateLabel: {
    fontWeight: 'bold',
    marginHorizontal: 15,
    color: colors.brandPrimary,
  },
  sportIconsContainer: {
    flexDirection: 'row',
    marginHorizontal: 4,
    marginVertical: 8,
  },
});

export default webStyles;
